import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import css from './toolbar.module.css';
import { ListParams } from '../../../../../services/http-client';
import DateFilter, {
  DateFields,
} from '../../../../../components/common/table/date-filter/date-filter';
import ValueFilter from '../../../../../components/common/table/value-filter/value-filter';
import { useService } from '../../../../../services/services';
import { useParams } from 'react-router-dom';
import { useQuery } from '../../../../../hooks/use-query';

const DEBOUNCE_TIME = 3000;

export default function Toolbar({ params: _ }: { params: ListParams }) {
  const { t } = useTranslation();
  const { farmId, id } = useParams<{ farmId: string; id: string }>();
  const { animalEventService } = useService();
  const transKeyPrefix = 'pages.livestock.animals_and_events.animals.';
  const tp = useCallback((key: string) => t(transKeyPrefix.concat(key)), [t]);
  const [subEvents, setSubEvents] = useState([]);
  const [params] = useQuery();
  useEffect(() => {
    const eventSub = animalEventService
      .subEventsByAnimal(farmId, {
        date_from: params['from'],
        date_to: params['to'],
        animal_id: id,
      })
      .subscribe((data) => {
        setSubEvents(data);
      });
    return () => {
      eventSub.unsubscribe();
    };
  }, [animalEventService, farmId, params, id]);

  return (
    <div className={css['animal-list-topbar']}>
      <div className={css['filter-bar']}>
        <div className={'flex items-center gap-5'}>
          <div className={css['filter-field']}>
            <label htmlFor="date_from">{tp('date_from')}</label>
            <DateFilter
              name={'date_from'}
              fields={[DateFields.from]}
              showDateControls={false}
              debounceTime={DEBOUNCE_TIME}
            />
          </div>

          <div className={css['filter-field']}>
            <label htmlFor="date_to">{tp('date_to')}</label>
            <DateFilter
              name={'date_to'}
              fields={[DateFields.to]}
              showDateControls={false}
              debounceTime={DEBOUNCE_TIME}
            />
          </div>
          <div className={css['filter-field']}>
            <label htmlFor="animal_events_type" className={css['filter-label']}>
              {tp('animal_events_type')}
            </label>
            <div className={css['subEvents-filter-container']}>
              <ValueFilter
                name="sub_event"
                options={subEvents}
                className={'value-filter-width-200'}
                isMulti={true}
                showSelectedCountInsteadOfValue={true}
                closeMenuOnSelect={false}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
